import type React from "react";
import { useEffect } from "react";

import { isEkidenMainnet } from "@constants";

declare global {
  interface Window {
    gtag: (command: string, ...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

interface GoogleAnalyticsProviderProps {
  children: React.ReactNode;
}

export const GoogleAnalyticsProvider: React.FC<GoogleAnalyticsProviderProps> = ({ children }) => {
  useEffect(() => {
    if (isEkidenMainnet) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = (...args: unknown[]) => {
        window.dataLayer.push(args);
      };

      window.gtag("js", new Date());
      window.gtag("config", "G-N5ZZ958CJ8");
    }
  }, []);

  return <>{children}</>;
};
